module.exports = __webpack_public_path__ + "img/icon_mianxi@2x.889d408b.png";